import { TableCell, TableRow, tableCellClasses } from "@mui/material";
import React from "react";
import styled from "styled-components";

import { useHistory } from "react-router-dom";
import { GetRolesResponse } from "../../../models/role.model";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#F9FAFC",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

interface Props {
  role: GetRolesResponse;
  index: number;
}

const RolePermissionTableRows = ({ role, index }: Props) => {
  const history = useHistory<{ roleId: number }>();
  return (
    <>
      <StyledTableRow
        sx={{ cursor: "pointer" }}
        onClick={() => {
          history.push({
            pathname: "/RolePermissionTabs",
            state: { roleId: role.id },
          });
          window.localStorage.setItem("RoleId", String(role.id));
          window.localStorage.setItem(
            "RoleNameTitle",
            JSON.stringify({ title: role.title, name: role.name })
          );
        }}
      >
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {index + 1}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {role.title}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {role.name}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {role.createDatePersian}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {role.creatorUserFullName}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {role.modifyDatePersian}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {role.modifierUserFullName}
          </p>
        </StyledTableCell>
      </StyledTableRow>
    </>
  );
};

export default RolePermissionTableRows;
